module.exports = __webpack_public_path__ + "static/media/c02-02-2.f612d7c8.png";